<rt-tabs margin-left-medium>
  <rt-tab routerLink="details" routerLinkActive="current">
    {{ 'app.requisitions.tabs.details' | translate }}
  </rt-tab>
  <rt-tab routerLink="flow" routerLinkActive="current">
    {{ 'app.requisitions.tabs.approval_flow' | translate }}
  </rt-tab>
  <rt-tab routerLink="notes" routerLinkActive="current" [count]="notesCount">
    {{ 'app.requisitions.tabs.notes' | translate }}
  </rt-tab>
  <rt-tab routerLink="files" routerLinkActive="current" [count]="attachmentsCount">
    {{ 'app.requisitions.tabs.files' | translate }}
  </rt-tab>
  <rt-tab routerLink="jobs" routerLinkActive="current" [count]="offersCount">
    {{ 'app.requisitions.tabs.jobs' | translate }}
  </rt-tab>
  <rt-tab
    routerLink="hires"
    routerLinkActive="current"
    [count]="openingsCount ? hiresTabCounter : 0"
  >
    {{ 'app.requisitions.tabs.hires' | translate }}
  </rt-tab>
  <rt-tab routerLink="team" routerLinkActive="current">
    {{ 'app.requisitions.tabs.team' | translate }}
  </rt-tab>
  <rt-tab routerLink="activity" routerLinkActive="current">
    {{ 'app.requisitions.tabs.activity' | translate }}
  </rt-tab>
</rt-tabs>
